// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-icon-delete[data-v-079354bd] {\n  margin-left: 10px;\n}\n.drawer-table[data-v-079354bd] {\n  width: 95%;\n  margin: auto;\n}\n.custom-btn[data-v-079354bd] {\n  margin-left: 10px;\n}\n.dialog-footer[data-v-079354bd] {\n  text-align: center;\n  margin-top: 25px;\n}\n.add-btn[data-v-079354bd] {\n  position: fixed;\n  right: 0;\n  top: 450px;\n  z-index: 99;\n}\n.model-select[data-v-079354bd] {\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
